window.Products.HomeDecor.PetBowl = function () {}
window.Products.HomeDecor.PetBowl.inherits(window.Products.HomeDecor.HomeDecor)